import DashboardIcon from '@mui/icons-material/Dashboard'
import WhatshotIcon from '@mui/icons-material/Whatshot'
import TimelineIcon from '@mui/icons-material/Timeline'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { Tooltip, Box, useTheme } from '@mui/material'

import { EScanRecordType } from 'src/types'

interface IProps {
  type: EScanRecordType
}

export const ScanRecordIcon = ({ type }: IProps) => {
  const theme = useTheme()

  const getIcon = () => {
    switch (type) {
      case EScanRecordType.General:
        return <DashboardIcon style={{ color: theme.palette.custom.grey2 }} />
      case EScanRecordType.Impact:
        return <WhatshotIcon style={{ color: theme.palette.custom.grey2 }} />
      case EScanRecordType.Movement:
        return <TimelineIcon style={{ color: theme.palette.custom.grey2 }} />
      default:
        return <HelpOutlineIcon style={{ color: theme.palette.custom.grey2 }} />
    }
  }

  return (
    <Tooltip title={type.charAt(0).toUpperCase() + type.slice(1)}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: '3px' }}>
        {getIcon()}
      </Box>
    </Tooltip>
  )
}
